export default __webpack_public_path__ + "static/media/food.0bf9f311.png";